import { render, staticRenderFns } from "./websiteInfo.vue?vue&type=template&id=27a5887a&"
import script from "./websiteInfo.vue?vue&type=script&lang=js&"
export * from "./websiteInfo.vue?vue&type=script&lang=js&"
import style0 from "./websiteInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports